export default "__VITE_ASSET__6abc11e7__"